import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import LinearProgress from "@mui/material/LinearProgress";
import { useGetAllStatusesQuery } from "entitites/employees/api/employeesApi";
import { StatusChip, Toast } from "shared";
import { SxProps } from "@mui/material/styles";
import { InputBaseComponentProps } from "@mui/material";

export const StatusSelect = ({
  sx,
  error,
  helperText,
  inputProps,
  value,
  onChange,
}: {
  sx?: SxProps;
  error?: boolean;
  helperText?: string;
  inputProps?: InputBaseComponentProps;
  value?: number | string;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}) => {
  const {
    data: statuses,
    isLoading,
    isUninitialized,
    isError,
    error: statussesError,
  } = useGetAllStatusesQuery();

  if (isLoading || isUninitialized) {
    return <LinearProgress sx={{ mt: -0.25, ml: -0.25 }} />;
  }

  if (isError) {
    return <Toast error={JSON.stringify(statussesError)} />;
  }

  return (
    <TextField
      onChange={onChange}
      value={value}
      error={error}
      helperText={helperText}
      inputProps={inputProps}
      sx={{ minWidth: 180, ...sx }}
      fullWidth
      label="Статус"
      select
      size="small"
      defaultValue=""
    >
      <MenuItem value="">
        <em>Выберите статус</em>
      </MenuItem>
      {statuses.map((status) => (
        <MenuItem key={status.id} value={status.id}>
          <StatusChip title={status.name} color={status.color} />
        </MenuItem>
      ))}
    </TextField>
  );
};
